import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { TranslationExtenderService } from '../services/translation-extender.service';

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const translationExtender = inject(TranslationExtenderService);

  if (authService.isAuthenticated()) {
    // Reuses the in-flight bootstrap promise — no duplicate HTTP request
    await authService.ensureCsrfReady();

    // Load remaining translation modules lazily (only loads once)
    await firstValueFrom(translationExtender.load());

    return true;
  }

  router.navigate([''], {
    queryParams: { returnUrl: state.url },
  });

  return false;
};
